import { useState, useEffect, useMemo } from 'react'
import { withTheme } from 'emotion-theming'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import { withTranslation } from 'server/i18n'

import style from './BoatStickyMenu.style'
import Button from '../Button'

const BoatStickyMenuStyled = styled.div(props => ({ ...style(props) }))

const BoatStickyMenu = ({ t, boatTitle, boatLengthOverAll, boatYear, boatPrice, boatID }) => {
    const [visibleByPosition, setVisibleByPosition] = useState(false)
    const [forceHidden, setForceHidden] = useState(false)

    const isVisible = useMemo(() => {
        return forceHidden ? false : visibleByPosition
    }, [visibleByPosition, forceHidden])

    const checkVisible = () => {
        setVisibleByPosition(window.scrollY >= window.innerHeight / 2)
    }
    const toggleMenu = e => {
        setForceHidden(e.detail.hide)
    }

    useEffect(() => {
        if (!process.browser) {
            return () => {}
        }
        window.addEventListener('scroll', checkVisible)
        window.addEventListener('toggleMenu', toggleMenu)
        checkVisible()
        return () => {
            window.removeEventListener('scroll', checkVisible)
            window.removeEventListener('toggleMenu', toggleMenu)
        }
    }, [])

    return (
        <BoatStickyMenuStyled isVisible={isVisible}>
            <div className="BoatStickyMenuContainer">
                <div className="Menu-StickyLeft">
                    <div className="boatTitle">{boatTitle}</div>
                    <div className="boatModel">
                        {boatLengthOverAll} m{boatYear ? <>, {boatYear}</> : null}
                    </div>
                </div>
                <div className="Menu-StickyRight">
                    <div className="boatPrice">{boatPrice}</div>
                    <Button
                        variation="tertiary"
                        dataAttrs={{
                            'gtm-event': 'link',
                            'gtm-label': 'Enquire',
                            'gtm-action': 'Enquire',
                            'gtm-category': 'Enquire'
                        }}
                        link={`/inquiry?boatID=${boatID}&type=buy`}>
                        {t('contact-broker')}
                    </Button>
                </div>
            </div>
        </BoatStickyMenuStyled>
    )
}

BoatStickyMenu.propTypes = {
    t: PropTypes.func.isRequired,
    boatTitle: PropTypes.string.isRequired,
    boatLengthOverAll: PropTypes.string.isRequired,
    boatYear: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    boatPrice: PropTypes.string.isRequired,
    boatID: PropTypes.string
}

BoatStickyMenu.defaultProps = {
    boatYear: null,
    boatID: null
}

export default withTranslation('common')(withTheme(BoatStickyMenu))
